import React from 'react';
import EventGalleryList from '../../features/EventsGallery/EventGalleryList';

const EventGallery= () => {
    return (<>
        <EventGalleryList />
    </>)
}
export default EventGallery;